<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoading" class="row">
            <div class="col-12">
                <navbaroptions isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow" v-bind:darkMode="true"
                    isBtn="bg-gradient-success" toRoute="/user-card/0" />
            </div>
            <div class=" row">
                <div class="col-12">
                    <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
                        <strong>Usuario!</strong> Eliminado correctamente!
                    </argon-alert>
                    <authors-table :users="users" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import AuthorsTable from "./components/AuthorsTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import { mapGetters } from "vuex";

export default {
    name: "users",
    components: {
        AuthorsTable,
        Navbaroptions,
        ArgonAlert
    },
    data() {
        return {
            isLoading: true,
            users: undefined,
            showAlert: false,
        };
    },
    created() {
        this.plain
            .get(`/users`, {
                headers: {
                    'Authorization': this.getAuthToken
                }
            })
            .then((response) => {
                // console.log("RESPONSE NUM USERS");
                // console.log(response.data);
                if (response.data.length !== 0) this.users = response.data;
                else this.users = [];
                this.isLoading = false;
                // console.log("RESPONSE USERS");
                // console.log(this.users);
            })
            .catch((err) => {
                this.users = [];
                this.isLoading = false;
                console.log(err);
            });
    },
    computed: {
        ...mapGetters('auth', ["getAuthToken"]),
    },
    methods: {
        deleteItemUser(userID) {
            this.showAlert = true;
            this.users = this.users.filter(({ id }) => id !== userID);
            // console.log("USERS USERS USERS");
            // console.log(this.users);
            window.scrollTo(0, 0);
        },
        closeAlert() {
            this.showAlert = false;
        },
    },
};
</script>

  